import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  IconButton,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import type { BucketsType } from "@/global/store/data/types";

export function BucketAccordion(props: {
  bucket: BucketsType;
  onToggleBucket: (bucketId: number) => void;
  children: React.ReactNode;
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const styles = useStyles(theme, isMobile);

  return (
    <Accordion
      sx={styles.accordion}
      expanded={props.bucket.opened}
      disabled={props.bucket.disabled}
      onChange={() => props?.onToggleBucket(props.bucket.id as number)}
    >
      <AccordionSummary
        expandIcon={
          <IconButton>
            <MdOutlineKeyboardArrowDown />
          </IconButton>
        }
        sx={{ ".MuiAccordionSummary-content": { margin: 0 } }}
      >
        <Box width="100%">
          <Typography variant="h6" fontWeight={"700"} color="text.primary">
            {props.bucket.title}
          </Typography>
          {props.bucket.description ? (
            <Box>
              <Box borderRadius={2} width={"100%"} height={"24px"} pr={1}>
                <Typography
                  fontSize={!isMobile ? "0.875rem" : "0.75rem"}
                  fontWeight={"500"}
                >
                  {props.bucket.description}
                </Typography>
              </Box>
            </Box>
          ) : null}
        </Box>
      </AccordionSummary>

      <AccordionDetails sx={styles.accordionDetails}>
        <Box mt={6} width={"100%"}>
          {props.children}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}

const useStyles = (theme: Theme, isMobile: boolean) => {
  const { palette } = theme;
  return {
    accordion: {
      paddingTop: 1,
      paddingBottom: 1,
      boxShadow: "none",
      borderRadius: "6 !important",
      border: `1px solid ${palette.divider}`,
      "&.MuiAccordionSummary-root": {
        paddingLeft: 2,
        paddingRight: 2,
      },
      "& .MuiAccordionSummary-expandIconWrapper svg": {
        width: "1.5rem",
        height: "1.5rem",
      },
      "&.MuiAccordion-root.Mui-expanded": {
        paddingBottom: isMobile ? "72px" : "initial",
      },
    },
    accordionDetails: { borderTop: `1px solid ${palette.divider}` },
  } as const;
};
